import { CREATING_STARTED } from '../types'

export const doSetToCreatingNew = () => {
  return {
    type: CREATING_STARTED,
  }
}
